import { render, staticRenderFns } from "./EcocarotidiView.vue?vue&type=template&id=2e07a638"
import script from "./EcocarotidiView.vue?vue&type=script&lang=js"
export * from "./EcocarotidiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports